import React from 'react'
import { Box, Chip, List } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CardWrapper from '../admin/CardWrapper'
import { themeConWeb } from '../../../util/modernThemeConweb'
import TitleCard from '../common/TitleCard'
import ListItemPerk from './ListItemPerk'
import SwitchOnOff from './SwitchOnOff'

const useStyles = makeStyles({
  h6: {
    color: themeConWeb.color.greyShade2,
  },
  body: {
    color: themeConWeb.color.greyShade3,
  },
  chip: {
    marginLeft: '16px',
  },
})

export default function CardGifts() {
  const classes = useStyles()

  return (
    <CardWrapper>
      <Box display="flex" flexDirection="row" alignItems="center">
        <TitleCard>Gifts</TitleCard>
        <Chip className={classes.chip} label="COMING SOON" />
      </Box>

      <List>
        <ListItemPerk
          primaryText="Birthday Gifts"
          primaryTypographyClass={classes.h6}
          secondaryText="Send gifts to your team members on their birthday."
          secondaryTypographyClass={classes.body}
          ActionComponent={<SwitchOnOff disabled />}
        />
        <ListItemPerk
          primaryText="Welcome Gifts"
          primaryTypographyClass={classes.h6}
          secondaryText="Send a welcome gift to your team members when they join your team."
          secondaryTypographyClass={classes.body}
          ActionComponent={<SwitchOnOff disabled />}
        />
        <ListItemPerk
          primaryText="Work Anniversary Gifts"
          primaryTypographyClass={classes.h6}
          secondaryText="Send gifts to your team members on their work anniversary."
          secondaryTypographyClass={classes.body}
          ActionComponent={<SwitchOnOff disabled />}
        />
      </List>
    </CardWrapper>
  )
}
